import { createCookieName } from '@app/utils/cookieNames'

export const COOKIE_NAME = createCookieName('kidsout_source')
export const EXPIRE_INTERVAL = 10 * 365 * 24 * 60 * 60 * 1000
